import { Routes } from '@angular/router';
import { publicPageWithUserGuard } from '../auth/public-page-with-user.guard';

export const publicRoutes: Routes = [
  {
    path: 'docs',
    loadComponent: () =>
      import('./public-documentation/public-documentation.component').then(
        (m) => m.PublicDocumentationComponent,
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            '../components/project-documentation/project-documentation.component'
          ).then((m) => m.ProjectDocumentationComponent),
        data: {
          isPublicRoute: true,
        },
      },
    ],
    canActivate: [publicPageWithUserGuard],
  },
];
